import React, { useState } from "react";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import "@elastic/charts/dist/theme_light.css";
import {
  EuiCollapsibleNav,
  EuiCollapsibleNavGroup,
  EuiHeaderSectionItemButton,
  EuiHeaderLogo,
  EuiHeader,
  EuiIcon,
  EuiButton,
  EuiPinnableListGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  useGeneratedHtmlId,
  EuiAvatar,
  EuiHeaderLink,
  EuiHeaderSectionItem,
  EuiHeaderLinks,
} from "@elastic/eui";

import { useHistory } from "react-router-dom";
import { Routes } from "../../common/routes";
import { HeaderUserMenu } from "../HeaderUserMenu/HeaderUserMenu";
import { selectLoggedInUser } from "../../features/auth/auth.slice";
import { useSelector } from "react-redux";

const TopLinks = [
  {
    label: "Home",
    iconType: "home",
    isActive: true,
    "aria-current": true,
    onClick: () => { },
    pinnable: false,
  },
];

const TopHeader = (props) => {
  const history = useHistory();
  const user = useSelector(selectLoggedInUser);
  const [navIsOpen, setNavIsOpen] = useState(false);

  const redirectTo = (path) => {
    history.push(path);
    setNavIsOpen(false);
  };
  const modules = Routes.map((el) => {
    const updatedChildRoutes = el.childRoutes.map((element) => ({
      ...element,
      onClick: () => {
        redirectTo(element.path);
      },
    }));
    return { ...el, childRoutes: updatedChildRoutes };
  });

  const [openGroups, setOpenGroups] = useState(
    JSON.parse(String(localStorage.getItem("openNavGroups"))) ||
    modules.map(({ label }) => label)
  );

  // Save which groups are open and which are not with state and local store
  const toggleAccordion = (isOpen, title) => {
    if (!title) return;
    const itExists = openGroups.includes(title);
    if (isOpen) {
      if (itExists) return;
      openGroups.push(title);
    } else {
      const index = openGroups.indexOf(title);
      if (index > -1) {
        openGroups.splice(index, 1);
      }
    }
    setOpenGroups([...openGroups]);
    localStorage.setItem("openNavGroups", JSON.stringify(openGroups));
  };

  /**
   * Pinning
   */
  const [pinnedItems, setPinnedItems] = useState(
    JSON.parse(String(localStorage.getItem("pinnedItems"))) || []
  );

  const addPin = (item) => {
    if (!item || find(pinnedItems, { label: item.label })) {
      return;
    }
    item.pinned = true;
    const newPinnedItems = pinnedItems ? pinnedItems.concat(item) : [item];
    setPinnedItems(newPinnedItems);
    localStorage.setItem("pinnedItems", JSON.stringify(newPinnedItems));
  };

  const removePin = (item) => {
    const pinIndex = findIndex(pinnedItems, { label: item.label });
    if (pinIndex > -1) {
      item.pinned = false;
      const newPinnedItems = pinnedItems;
      newPinnedItems.splice(pinIndex, 1);
      setPinnedItems([...newPinnedItems]);
      localStorage.setItem("pinnedItems", JSON.stringify(newPinnedItems));
    }
  };

  function alterLinksWithCurrentState(links, showPinned = false) {
    return links.map((link) => {
      const { pinned, ...rest } = link;
      return {
        pinned: showPinned ? pinned : false,
        ...rest,
      };
    });
  }

  function addLinkNameToPinTitle(listItem) {
    return `Pin ${listItem.label} to top`;
  }

  function addLinkNameToUnpinTitle(listItem) {
    return `Unpin ${listItem.label}`;
  }

  const collapsibleNavId = useGeneratedHtmlId({ prefix: "collapsibleNav" });

  const collapsibleNav = (
    <EuiCollapsibleNav
      id={collapsibleNavId}
      aria-label="Main navigation"
      isOpen={navIsOpen}
      button={
        <EuiHeaderSectionItemButton
          aria-label="Toggle main navigation"
          onClick={() => setNavIsOpen(!navIsOpen)}
        >
          <EuiIcon type={"menu"} size="m" aria-hidden="true" />
        </EuiHeaderSectionItemButton>
      }
      onClose={() => setNavIsOpen(false)}
    >
      {/* Dark deployments section */}
      {/* <EuiFlexItem grow={false} style={{ flexShrink: 0 }}>
        <EuiCollapsibleNavGroup isCollapsible={false} background="dark">
          <EuiListGroup
            color="ghost"
            maxWidth="none"
            gutterSize="none"
            size="s"
            listItems={[
              {
                label: "Manage deployment",
                href: "#",
                iconType: "logoCloud",
                iconProps: {
                  color: "ghost",
                },
              },
            ]}
          />
        </EuiCollapsibleNavGroup>
      </EuiFlexItem> */}

      {/* Shaded pinned section always with a home item */}
      <EuiFlexItem grow={false} style={{ flexShrink: 0 }}>
        <EuiCollapsibleNavGroup
          background="light"
          className="eui-yScroll"
          style={{ maxHeight: "40vh" }}
        >
          <EuiPinnableListGroup
            aria-label="Pinned links" // A11y : Since this group doesn't have a visible `title` it should be provided an accessible description
            listItems={alterLinksWithCurrentState(TopLinks).concat(
              alterLinksWithCurrentState(pinnedItems, true)
            )}
            unpinTitle={addLinkNameToUnpinTitle}
            onPinClick={removePin}
            maxWidth="none"
            color="text"
            gutterSize="none"
            size="s"
          />
        </EuiCollapsibleNavGroup>
      </EuiFlexItem>

      <EuiHorizontalRule margin="none" />

      {/* BOTTOM */}
      <EuiFlexItem className="eui-yScroll">
        {/* Report section */}
        {modules.map((moduleInfo) => {
          return (
            <EuiCollapsibleNavGroup
              title={
                <a
                  className="eui-textInheritColor"
                  href="#"
                  onClick={(e) => e.stopPropagation()}
                // to="/configure"
                >
                  {moduleInfo.label}
                </a>
              }
              iconType={moduleInfo.iconType}
              isCollapsible={true}
              initialIsOpen={openGroups.includes(moduleInfo.label)}
              onToggle={(isOpen) => toggleAccordion(isOpen, moduleInfo.label)}
            >
              <EuiPinnableListGroup
                aria-label={moduleInfo.label} // A11y : EuiCollapsibleNavGroup can't correctly pass the `title` as the `aria-label` to the right HTML element, so it must be added manually
                listItems={alterLinksWithCurrentState(moduleInfo.childRoutes)}
                pinTitle={addLinkNameToPinTitle}
                onPinClick={addPin}
                maxWidth="none"
                color="subdued"
                gutterSize="none"
                size="s"
              />
            </EuiCollapsibleNavGroup>
          );
        })}
      </EuiFlexItem>

      <EuiFlexItem grow={false}>
        {/* Span fakes the nav group into not being the first item and therefore adding a top border */}
        <span />
        <EuiCollapsibleNavGroup>
          <EuiButton
            fill
            fullWidth
            iconType="plusInCircleFilled"
            onClick={() => redirectTo("/manage/upload")}
          >
            Add Invoice
          </EuiButton>
        </EuiCollapsibleNavGroup>
      </EuiFlexItem>
    </EuiCollapsibleNav>
  );

  const leftSectionItems = [
    collapsibleNav,
    <EuiHeaderLogo iconType="notebookApp">MeekNeil Inc.</EuiHeaderLogo>,
  ];

  return (
    <EuiHeader
      position="fixed"
      sections={[
        {
          items: leftSectionItems,
          borders: "right",
        },
        {
          items: [
            <EuiHeaderSectionItem>
              <EuiHeaderLinks aria-label="App navigation links example">
                {/* <EuiHeaderLink isActive>Docs</EuiHeaderLink>

                  <EuiHeaderLink>Code</EuiHeaderLink> */}

                <EuiHeaderLink>
                  {" "}
                  <EuiButton
                    fill
                    size="s"
                    iconType="plusInCircleFilled"
                    onClick={() => redirectTo("/manage/upload")}
                  >
                    Add Invoice
                  </EuiButton>
                </EuiHeaderLink>
              </EuiHeaderLinks>
            </EuiHeaderSectionItem>,
            <EuiHeaderSectionItemButton aria-label="Account menu">
              {user && <HeaderUserMenu user={user} />}
            </EuiHeaderSectionItemButton>,
          ],
        },
      ]}
    />
  );
};

export default TopHeader;
